(function () {
    'use strict';

    angular.module('swif.interventions')
    .config(route)
    .controller('InterWizardInterventionCategories', InterWizardInterventionCategories)
    .controller('InterWizardTaskCategories', InterWizardTaskCategories)
    .controller('InterWizardAbsenceCategories', InterWizardAbsenceCategories);

    function route ($routeProvider) {
        'ngInject';
        $routeProvider.when('/interventions/wizard', {
            templateUrl: 'partials/openstc/wizard_view.html',
            controller: 'OpenbaseWizardController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
    }

    function InterWizardInterventionCategories($scope, swif, openbaseWizardService) {
        'ngInject';
        $scope.contentType = 'intervention_category';
        $scope.heads = 'Nom';
        $scope.items = {};
        //fields of the object
        $scope.fields = ['name'];
        //fields for import params
        var fields = ['name'];
        openbaseWizardService.load_json($scope.items, 'json/wizard_intervention_categories.json');
        $scope.import_data = function () {
            swif.message.loading($scope.loading.import);
            var data = openbaseWizardService.pre_import_data($scope.items.selected, $scope.fields);
            openbaseWizardService.import_data($scope.contentType, fields, data)
            .then(function () {
                swif.message.loading($scope.loading.import, 'ok');
                swif.message.addInfo('data imported successfully');
            });
        };
    }

    function InterWizardTaskCategories($scope, swif, openbaseWizardService) {
        'ngInject';
        $scope.contentType = 'task_category';
        $scope.heads = 'Nom';
        $scope.items = {};
        //fields of the object
        $scope.fields = ['name'];
        //fields for import params
        var fields = ['name'];
        openbaseWizardService.load_json($scope.items, 'json/wizard_task_categories.json');
        $scope.import_data = function () {
            swif.message.loading($scope.loading.import);
            var data = openbaseWizardService.pre_import_data($scope.items.selected, $scope.fields);
            openbaseWizardService.import_data($scope.contentType, fields, data)
            .then(function () {
                swif.message.loading($scope.loading.import, 'ok');
                swif.message.addInfo('data imported successfully');
            });
        };
    }

    function InterWizardAbsenceCategories ($scope, swif, openbaseWizardService) {
        'ngInject';
        $scope.contentType = 'absence_category';
        $scope.heads = 'Nom,Description';
        $scope.items = {};
        //fields of the object
        $scope.fields = ['name', 'description'];
        //fields for import params
        var fields = ['name', 'description'];
        openbaseWizardService.load_json($scope.items, 'json/wizard_absence_categories.json');
        $scope.import_data = function () {
            swif.message.loading($scope.loading.import);
            var data = openbaseWizardService.pre_import_data($scope.items.selected, $scope.fields);
            openbaseWizardService.import_data($scope.contentType, fields, data)
            .then(function () {
                swif.message.loading($scope.loading.import, 'ok');
                swif.message.addInfo('data imported successfully');
            });
        };
    }

})();
